<template>
  <van-popup
    v-model:show="showPopup"
    position="bottom"
    :style="{ height: '100%' }"
  >
    <div class="pay-status">
      <div v-if="payStatus === 'ing'" class="pay-hd">
        <div class="icon">
          <van-icon color="#00c250" name="wechat-pay" size="80px" />
        </div>
        <div class="status">支付中...</div>
        <div style="margin-top: 50px">
          <van-loading size="30px" type="spinner" vertical />
        </div>
      </div>
      <div v-if="payStatus === 'done'" class="pay-hd">
        <div class="icon">
          <van-icon color="#00c250" name="wechat-pay" size="80px" />
        </div>
        <div class="status succ">支付成功</div>
        <!-- <div class="money">￥{{ moneyStr(money) }}</div> -->
        <div class="pay-bd">
          <div style="padding: 30px 20px">
            恭喜你已完成支付，请等待老师审核，先逛逛其他的吧
          </div>
          <van-button block color="#000" @click="goService">去逛逛</van-button>
        </div>
      </div>
      <!-- <div v-if="payInfo.TradeState === 20" class="pay-bd">
        <div
          v-if="payInfo.OrderCashierInfo.RemainAmount > 0"
          class="remain-amount"
        >
          <div class="flex">
            <div class="flex-1">累计支付</div>
            <div>￥{{ moneyStr(money) }}</div>
          </div>
          <div class="flex">
            <div class="flex-1">剩余应付</div>
            <div class="remain-text">￥{{ moneyStr(money) }}</div>
          </div>
          <div style="margin-top: 30px">
            <van-button block color="#000" @click="goPay">继续支付</van-button>
          </div>
        </div>
        <div v-else class="text-center">
          <div style="padding: 30px 20px">
            恭喜你已完成支付，请等待老师审核，先逛逛其他的吧
          </div>
          <van-button block color="#000" @click="goService">去逛逛</van-button>
        </div>
      </div> -->

      <!-- 支付超时 -->
      <div v-if="payStatus === 'timeout'">
        <div class="pay-hd">
          <div class="icon">
            <van-icon color="#00c250" name="wechat-pay" size="80px" />
          </div>
          <div class="status">支付超时</div>
        </div>
        <div class="pay-bd">
          <div class="text-center">
            <div style="padding: 30px 20px">
              支付结果返回超时，如果你已支付请等待老师审核
            </div>
          </div>
        </div>
      </div>
      <!-- 取消支付 -->
      <div v-if="payStatus === 'cancel'">
        <div class="pay-hd">
          <div class="icon">
            <van-icon color="#00c250" name="wechat-pay" size="80px" />
          </div>
          <div class="status">取消支付</div>
        </div>
        <div class="pay-bd">
          <div class="text-center">
            <van-button block color="#000" @click="goPay">继续支付</van-button>
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>
<script setup>
  import { defineExpose, ref } from 'vue'
  import store from '@/store'
  import { Toast } from 'vant'
  import { moneyStr } from '@/utils/filters'
  const showPopup = ref(false)
  let money = ref() // 展示用money
  let payStatus = ref('') // ing = 支付中 timeout = 支付超时 cancel = 取消支付  done=支付完成 failed支付失败
  const show = (amount, status = 'ing') => {
    showPopup.value = true
    money.value = amount
    payStatus.value = status
    //getPayStatus(outTradeNo)
  }

  const payInfo = ref({})
  let times = 0
  // const getPayStatus = (outTradeNo) => {
  //   // 如果返回成功或取消就不刷新状态了
  //   if (payStatus.value !== 'ing') return
  //   // 拉新20次如果都不成功就提示
  //   if (times > 10) {
  //     payStatus.value = 'timeout'
  //     return
  //   }
  //   store
  //     .dispatch('pay/QueryTransactionStatus', { outTradeNo })
  //     .then((data) => {
  //       const { Code, Data } = data
  //       if (Code === 0) {
  //         payInfo.value = Data
  //       }

  //       if ((Data && Data.TradeState === 0) || !Data) {
  //         setTimeout(() => {
  //           times++
  //           getPayStatus(outTradeNo)
  //         }, 3000)
  //       }
  //     })
  //     .catch((e) => {
  //       payStatus.value = false
  //       Toast.fail(e.Message || '获取支付信息失败')
  //     })
  // }
  //跳转至服务首页
  const goService = async () => {
    const tenant = await store.getters['user/getTenant']
    const H5URL = await store.getters['system/getH5Url']
    location.href = `${H5URL}service/#/home/index`
  }

  const goPay = async () => {
    showPopup.value = false
  }

  // 暴露给refs用
  defineExpose({ show })
</script>
<style lang="scss" scoped>
  .pay-status {
    .pay-hd {
      padding-top: 50px;
      text-align: center;
      .status {
        font-size: 26px;
        margin: 16px 0;
      }
      .money {
        font-size: 26px;
      }
    }
    .pay-bd {
      margin: 36px 20px;
      padding: 20px;
      line-height: 1.4;
    }
    .remain-text {
      color: #ff185d;
    }
  }
  .succ {
    color: #00c250;
  }
  .remain-amount {
    line-height: 2.2;
  }
</style>
